import { useLpConfig } from "routes/LandingPage/LpConfigContext";
import { trackLpCta } from "routes/LandingPage/lp-analytics";

/**
 * スマホ幅で画面下に固定する CTA ボタン。設定の `floatingCta` を読む
 * @return {JSX.Element} 固定 CTA
 */
export function LpFloatingCta() {
  const { floatingCta } = useLpConfig();

  return (
    <div className="fixed bottom-6 left-6 right-6 z-40 md:hidden">
      <a
        href={floatingCta.href}
        onClick={() => trackLpCta("mobile_sticky", floatingCta.href)}
        className="w-full bg-[#ff8d00] text-white py-4 rounded-2xl font-bold text-lg shadow-2xl flex items-center justify-center gap-2 active:scale-95 transition-transform"
        style={{ boxShadow: "0 8px 32px rgba(255, 141, 0, 0.4)" }}
      >
        {floatingCta.label}
      </a>
    </div>
  );
}
